// extracted by mini-css-extract-plugin
module.exports = {"notifications":"_3-iFaDrx mt1","log-in":"_2XE16fQa bold","logIn":"_2XE16fQa bold"};